<script>
    import { onMount } from 'svelte';

    export let count = 0;
    export let rounded = 0;
    export let perc = 0;

    const deathsPerMinute = 0.0578923135;
    const deathsPerSecond = deathsPerMinute / 60;

    function secondsSinceReport(){
        const firstDate = new Date(2017, 10, 16);
        var secondDate = new Date();
        return Math.round(Math.abs((firstDate - secondDate) / 1000));
    }

    function deathCounter(){
        var deaths = (deathsPerSecond * secondsSinceReport()) + 120000;
        console.log(deaths);
        return deaths;
    }

    function percCalc(){
        var split = [(count > 0) ? Math.floor(count) : Math.ceil(count), count % 1];
        var p = (split[1] * 100);
        return p;
    }

    onMount(() => {
        const interval = setInterval(() => {
            count = deathCounter();
            rounded = Math.floor(count);
            perc = percCalc();
        }, 1000);

        return () => clearInterval(interval);
    });

</script>

<div id="wrapper">
<header>
    <h1>Conservatives asuterity death counter</h1>
</header>

<main>
	<section class="intro">
        <h2>Thank you for voting Conservative</h2>
        <p>Together, thanks to <em>you</em>, we've killed {rounded} elderly, poor and vulnerable people and we couldn't have done it without you. To say thank you, we've put together this live counter so you can see, in real time, how many British citizens you've helped us murder through austerity. Together, we can Get Genocide Done™.</p>
    </section>
    <section class="death">
        <h2 class="austerity-death-count">{rounded}</h2>
        <div class="progress-bar">
            <div style="width: {perc}%; height: 20px; background-color: #003b81">&nbsp;
            </div>
        </div>
    </section>
</main>
<aside>
    * Numbers sourced and extrapolated from <a href="https://bmjopen.bmj.com/content/7/11/e017722">this BMJ Open research paper</a>
</aside>
<footer>
    <div class="footer-links">
        <a href="/"><img src="/img/tree-of-evil.svg" alt=""></a>
        <a class="txt" href="https://www.commonspace.scot/articles/13116/8-times-boris-johnson-has-made-bigoted-remarks-and-faced-no-consequences">Meet Boris</a>
        <a class="txt" href="https://inews.co.uk/news/health/great-nhs-gamble-full-list-19-hospitals-facing-closure-529275">Manifesto</a>
        <a class="txt" href="https://www.thelondoneconomic.com/news/man-dies-in-job-centre-queue-after-being-declared-fit-to-work/18/11/">News</a>
        <a class="txt" href="https://do-it.org">Volunteer</a>
        <a class="txt" href="https://do-it.org">Join</a>
        <a class="txt" href="https://do-it.org">Sign Up</a>
        <a class="txt" href="https://www.charitychoice.co.uk">Donate</a>
    </div>
</footer>
</div>

<style>
    aside{
        color: #aaa;
        padding: 1.5em;
    }
    aside a{
        color: #abc;
    }
    body{
        padding: 0 !important;
        margin: 0;
    }
    div.progress-bar{
        margin: 0 auto;
        width: 69vw;
        height: 20px;
        border: 1px solid grey;
        margin-bottom: 80px;
    }
    div#wrapper{
        padding: 0;
        margin: 0;
        display: flex;
        min-height: 100vh;
        flex-direction: column;
    }
    header{
        margin-top: 0;
        padding: 40px;
    }
    section.intro{
        text-align: left;
    }
    section.intro h2{
        font-size: 13vw;
    }
    h2.austerity-death-count{
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 20.5vw;
    }
    footer{
        font-family: "Proxima Nova" sans-serif;
        background-color: #003b81;
        color: white;
        min-height: 100px;
        padding: 40px;
    }
    div.footer-links{
        display: flex;
        flex-direction: column;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
    }
    footer a{
        display: block;
        float: left;
        color: white;
        margin: 0 auto;
    }
    footer a.txt{
        margin-top: 10px;
    }
    header h1{
        background-image: url(/img/tories-kill.svg);
        background-width: 100%;
        background-repeat: no-repeat;
        width: 200px;
        text-indent: -9999px;
        margin: 0;
    }
	main {
        display: flex;
        flex: 1;
		text-align: center;
		padding: 0 1.5em;
		margin: 0 auto;
        flex-direction: column;
	}

    main section{
        flex: 1;
    }

    main h2{
        color: #003b81;
    }

    main p{
        font-size: 1.2em;
    }

	@media (min-width: 705px) {
        main p{
            font-size: 1.5em;
        }
        aside{
            padding: 80px;
        }
        header h1{
            width: 300px;
        }
		main {
			max-width: none;
            padding: 0 4.5em;
            flex-direction: row;
		}
        main h2{
            font-size: 10.5vw;
        }
        div.footer-links{
            display: inline-block;
        }
        footer a{
            margin-right: 20px;
        }
        main section{
            flex: 1;
        }
        div.progress-bar{
            width: 35vw;
        }
        section.intro h2{
            font-size: 4vw;
        }
	}
</style>
